import { yup } from '@guiker/shared-framework'

export const updatePropRentalPayoutMethodSchema = yup.object({
  payoutMethodId: yup.string().required(),
})
